function getCourseFullName (course, courseAlias = 'Course') {
  const notFound = `${courseAlias} Not Found`
  if (!course) return notFound
  const title = `${course.subjectCode || ''}${course.courseNumber || ''} ${course.name || ''}`.trim()
  if (!title) return notFound
  const requestStatus = course.requestStatus === 'pending' ? '(Pending)' : ''
  return [ title, requestStatus ].filter(Boolean).join(' ').trim()
}

module.exports = { getCourseFullName }
